<button
  pButton
  [type]="type"
  [label]="label"
  [icon]="icon"
  [iconPos]="iconPos"
  [outlined]="outlined"
  [ngClass]="customClass"   
  (click)="onClick()"       
></button>